module.exports = __webpack_public_path__ + "img/33.a71cabd9.jpg";